import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { EconomyService } from '../../../services/economy.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-business-sites',
  templateUrl: './business-sites.component.html',
  styleUrls: ['./business-sites.component.css']
})
export class BusinessSitesComponent implements OnInit {
    public itemsListBusinessSites: Item[] = [];

    constructor(private state: StateService, private economy: EconomyService) { }

    private async loadBusinessSites() {
        this.itemsListBusinessSites = await this.economy.getBusinessSites();
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'businesssite':
                this.state?.go('businesssite', { businesssite_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadBusinessSites();
    }

    ngOnInit() {
        this.init();
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('businessSites', {
//        templateUrl: 'views/components/views/businessSites/businessSites.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'economyService', function (stateService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListBusinessSites: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadBusinessSites() {
//                vm.model.itemsListBusinessSites = (await economyService.listBusinessSites());
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'businesssite':
//                        go({ businesssite_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadBusinessSites();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
